import React, { useState, useEffect } from 'react';
import { Navbar, Container, Nav, Button } from 'react-bootstrap';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { LogOut, Film, PlusCircle } from 'lucide-react';

const Navigation = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [scrolled, setScrolled] = useState(false);

    // Effet pour changer le style au scroll
    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/login');
    };

    return (
        <Navbar 
            expand="lg" 
            fixed="top"
            className={`custom-nav ${scrolled ? 'nav-scrolled' : ''}`}
            variant="dark"
        >
            <Container fluid className="px-lg-5">
                <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
                    <Film className="brand-icon me-2" color="#e50914" size={28} fill="#e50914" /> 
                    <span className="brand-text">GPSTREAM</span>
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="basic-navbar-nav" className="border-0" />
                
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto ms-4 gap-3">
                        <Nav.Link 
                            as={Link} 
                            to="/" 
                            className={`nav-link-custom ${location.pathname === '/' ? 'active' : ''}`}
                        >
                            Accueil
                        </Nav.Link>
                        <Nav.Link 
                            as={Link} 
                            to="/upload" 
                            className={`nav-link-custom d-flex align-items-center ${location.pathname === '/upload' ? 'active' : ''}`}
                        >
                            <PlusCircle size={16} className="me-1" /> Ajouter un film
                        </Nav.Link>
                    </Nav>

                    <Nav className="align-items-center">
                        <Button 
                            variant="link" 
                            onClick={handleLogout}
                            className="logout-btn text-decoration-none d-flex align-items-center"
                        >
                            <LogOut size={18} className="me-1" /> Déconnexion
                        </Button>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Navigation;